<template>
	<ul v-if="items">
		<template>
			<li v-for="(item,i) of items" :key="i" :class="[{'active-menuitem': (activeIndex === i && !item.to)|| routeArr === item.to}]">
				<div v-if="item.items && root===true" class='arrow'></div>
				<a class="sub-menu-link" :id="item.id" v-if="item.to" :href="item.to" :class="[{'active-route': activeIndex === i || routeArr === item.to}]" @click="onMenuItemClick($event,item,i)" :target="item.target" exact>
					<i :class="`${(item.icon || 'fa fa-circle-o')} mr-2`"></i>
					<span class="custom-sub">{{item.label}}</span>
					<i v-if="item.items" class="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>
					<span v-if="item.badge" class="menuitem-badge">{{item.badge}}</span>
					<Badge class="style_badge" v-if="item.to === '/admin/chat' && $store.state.countUnread>0 " :value="$store.state.countUnread" severity="danger"></Badge>
					<Badge class="style_badge" v-if="item.to === '/admin/list-rental_order' && total_badge_rental_order_key > 0" :value="total_badge_rental_order_key" severity="danger" ></Badge>
					<Badge class="style_badge" v-if="item.to === '/admin/list-visit_list' && total_badge_visit > 0" :value="total_badge_visit" severity="danger" ></Badge>
					<Badge class="style_badge" v-if="item.to === '/admin/list-rental_order_sell' && total_badge_purchase_request > 0" :value="total_badge_purchase_request" severity="danger"></Badge>
				</a>
				<a v-if="!item.to" :href="item.url||'#'" @click="onMenuItemClick($event,item,i)" target="item.target">
					<i :class="`${(item.icon || 'fa fa-circle-o')} mr-2`"></i>
					<span>{{item.label}}</span>
					<i v-if="item.items" class="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>
					<span v-if="item.badge" class="menuitem-badge">{{item.badge}}</span>
					<Badge class="style_badge" v-if="item._key === 'list_marketing' && $store.state.countUnread >0 " :value="$store.state.countUnread" severity="danger"></Badge>
					<Badge class="style_badge" v-if="item._key === 'list_property_manager' && total_badge_rental_order_key > 0" :value="total_badge_rental_order_key" severity="danger"></Badge>
					<Badge class="style_badge" v-if="item._key === 'list_sale_purchase' && total_badge_all_visit > 0" :value="total_badge_all_visit" severity="danger"></Badge>
				</a>
				<transition name="layout-submenu-wrapper">
					<AppSubmenu :total_badge_all_visit="total_badge_all_visit" :total_badge_visit="total_badge_visit" :total_badge_purchase_request="total_badge_purchase_request" :total_badge_rental_order_key="total_badge_rental_order_key" v-show="activeIndex === i" :items="item.items" @menuitem-click="$emit('menuitem-click', $event)"></AppSubmenu>
				</transition>
			</li>
		</template>
	</ul>
</template>
<script>
export default {
	name: 'AppSubmenu',
	props: {
		items: Array,
		root: {
			type: Boolean,
			default: false
		},
		//type int
		total_badge_rental_order_key: {
			type: Number,
			default: 0
		},
		total_badge_visit: {
			type: Number,
			default: 0
		},
		total_badge_purchase_request: {
			type: Number,
			default: 0
		},
		total_badge_all_visit: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			activeIndex : null,
			currentPath: this.$router.currentRoute.path,
			// routeAdd: this.$router.currentRoute.path.split('/add'),
			// routeView: this.$router.currentRoute.path.split('/view'),
			// routeEdit: this.$router.currentRoute.path.split('/edit'),
			myInterval: setInterval(this.loadActiveMenu, 100),
			routeArr: this.$router.currentRoute.path,
		}
	},
	watch: {
		async $route() {
			let path = this.$router.currentRoute.path;
			let routeArr = path.split('/');
			let routeArr_tmp = [routeArr[0],routeArr[1],routeArr[2]];
			this.routeArr = routeArr_tmp.join("/");
			setTimeout(async () => {
				this.loadActiveMenu(false);
			}, 100)
		},
		"routeArr"() {
			this.loadActiveMenu();
		}
	},
	mounted() {
		let path = this.$router.currentRoute.path;
		let routeArr = path.split('/');
		let routeArr_tmp = [routeArr[0],routeArr[1],routeArr[2]];
		this.routeArr = routeArr_tmp.join("/");
	},
	// created() {
	// 	let path = this.$router.currentRoute.path;
	// 	let routeArr = path.split('/');
	// 	let routeArr_tmp = [routeArr[0],routeArr[1],routeArr[2]];
	// 	this.routeArr = routeArr_tmp.join("/");
	// },
	methods: {
		async loadActiveMenu(activeMenu=true) {
			var activeRouteNewArr = [];
			this.$nextTick(async () => {
				this.$nextTick( async () => {
					var activeRoute = document.querySelectorAll('.active-route');
					for (let i=0; i < activeRoute.length; i++) {
						var activeRouteNew = activeRoute[i];
						// if (this.routeArr.includes(activeRouteNew.getAttribute("href"))) {
						if (this.routeArr === activeRouteNew.getAttribute("href")) {
							if (activeRouteNew && activeMenu) {
								var parentRoute = activeRouteNew.closest('ul');
								if (parentRoute && parentRoute.style.display == "none") {
									var grandParentRoute = parentRoute.closest('li');
									if (grandParentRoute) {
										var childElement = grandParentRoute.children;
										if (!this.$commonFuction.isEmpty(childElement)) {
											clearInterval(this.myInterval);
											parentRoute.click();
											for (let c = 0; c < childElement.length; c++) {
												await childElement[c].click();
											}
										}
									}
								}
							}
						} else {
							activeRouteNewArr.push(activeRouteNew);
						}
					}
					activeRouteNewArr.map(m => {
						m.classList.remove("active-route");
					})
				})
			});
		},
		onMenuItemClick(event, item, index) {
			//|| this.routeArr == item.to
			if (item.disabled ) {
				event.preventDefault();
				return;
            }
            
            if (!item.to && !item.url) {
                event.preventDefault();
            }

			//execute command
			if (item.command) {
                item.command({originalEvent: event, item: item});
			}

			this.activeIndex = index === this.activeIndex ? null : index;
			this.currentPath = null;
			this.routeArr = [];
			//chặn href load thêm lần nữa
			event.preventDefault();
			this.$emit('menuitem-click', {
				originalEvent: event,
				item: item
			});
		}
	},
	components: {
		"AppSubmenu": this
	}
}
</script>

<style scoped>
	.custom-sub{
		/* font-size: 16px; */
	}
	.sub-menu-link {
		display: flex;
		align-items: center;
	}
	.menuitem-badge-counter {
		background: #EF0304;
		border-color: #EF0304;
		border-radius: 100%;
		animation: blink 2s cubic-bezier(0.32, 0, 0.67, 0) 0.2s infinite alternate-reverse backwards;
	}
	@keyframes blink {
		0%,
		50%,
		100% {
			opacity: 1;
		}

		25%,
		75% {
			opacity: 0;
		}
	}
	.style_badge{
		line-height: 22px !important;
	}
</style>